import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  Show,
  SimpleShowLayout,
  TextField,
  FunctionField,
  useDataProvider,
  useGetRecordId,
} from "react-admin";
import { useEffect, useState } from "react";

const MemberList = () => {
  const dataProvider = useDataProvider();
  const groupId = useGetRecordId();
  const [members, setMembers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const path = `organizations/${groupId}/members`;

  useEffect(() => {
    dataProvider
      .getList(path, {
        filter: {},
        pagination: { page: 1, perPage: 10 },
        sort: { field: "name", order: "ASC" },
      })
      .then(({ data }) => {
        setMembers(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [dataProvider, groupId, path]);

  if (loading) {
    return <Typography variant="body2">加载中...</Typography>;
  }

  if (members.length === 0) {
    return <Typography variant="body2">无组员</Typography>;
  }

  return (
    <Box>
      <Typography variant="body2">组员：</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>姓名</TableCell>
              <TableCell>用户名</TableCell>
              <TableCell>邮箱</TableCell>
              <TableCell>邮箱验证</TableCell>
              <TableCell>启用</TableCell>
              <TableCell>创建时间</TableCell>
              <TableCell>语言</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {members.map((member: any) => (
              <TableRow key={member.id}>
                <TableCell>{`${member.firstName} ${member.lastName}`}</TableCell>
                <TableCell>{member.username}</TableCell>
                <TableCell>{member.email}</TableCell>
                <TableCell>{member.emailVerified ? "是" : "否"}</TableCell>
                <TableCell>{member.enabled ? "是" : "否"}</TableCell>
                <TableCell>
                  {new Date(member.createdTimestamp).toLocaleString("zh-CN", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                  })}
                </TableCell>
                <TableCell>
                  {member.attributes?.locale?.join(", ") || "无"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export const OrganizationShow = (props: any) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" label="企业名称" />
        <TextField source="alias" label="别名" />
        <FunctionField
          label="启用"
          render={(record: any) => (record.enabled ? "是" : "否")}
        />
        <TextField source="description" label="描述" />
        <FunctionField
          label="属性"
          render={(record: any) =>
            record.attributes && Object.keys(record.attributes).length > 0
              ? JSON.stringify(record.attributes)
              : "无"
          }
        />
        <FunctionField
          label="域名"
          render={(record: any) =>
            record.domains && record.domains.length > 0
              ? record.domains
                  .map(
                    (domain: any) =>
                      `${domain.name} (验证: ${domain.verified ? "是" : "否"})`
                  )
                  .join(", ")
              : "无"
          }
        />
        <MemberList />
      </SimpleShowLayout>
    </Show>
  );
};
